import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Network Security images
import dataCentreImage from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';
import structuredCablingImage from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';

// Import IT Security video (can be reused for Network Security)
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import benefits image
import networkBenefitsImage from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';

const NetworkSecurityPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Network Security" description="Network security and structured cabling services in DRC. Data centre setup, networking infrastructure by Cool & Care." keywords="network security DRC, structured cabling, data centre setup, networking Kinshasa" />
      <ServiceSchema name="Network Security" description="Network security, structured cabling, and data centre setup services." url="/network-security" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Network Security', url: '/network-security' }]} />
      <ServicePage
        serviceName={t('servicePage.services.networkSecurity.name')}
      serviceDescription={t('servicePage.services.networkSecurity.description')}
      videoUrl={itVideo}
      productImages={[
        dataCentreImage,
        structuredCablingImage
      ]}
      features={t('servicePage.services.networkSecurity.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.networkSecurity.benefits', { returnObjects: true }) as string[]}
      benefitsImage={networkBenefitsImage}
    />
    </>
  );
};

export default NetworkSecurityPage;
